import { RekognitionResultResponseItem } from "../../../../../../../../common/api/master-api/qc/GetRekognitionResultByIdResponse";

export interface RekognitionResultItem {
    key: string;
    type: string;
    confidence: number;
    startTimestamp: number;
    endTimestamp: number;
}

export const mapToRekognitionResultItem = (item: RekognitionResultResponseItem): RekognitionResultItem => {
    return {
        key: item.id,
        type: item.type,
        confidence: item.confidence,
        startTimestamp: item.startTimestamp,
        endTimestamp: item.endTimestamp
    };
};
